// import ScrollMagic from 'ScrollMagic';
import dragula from 'dragula/dist/dragula.js';

'use strict';


var ad_contentCollection = function () {
  var self = this;

  self.init();
  self.bind();
};

ad_contentCollection.prototype.init = function () {
  var self = this;

  // console.log('init ad_contentCollection');

  self.INSTANCES_DROPPED_COUNTER = 0;

  self.init_sortable();
  self.init_modals();
  self.adjustWidth();

};

ad_contentCollection.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_contentCollection');

  // Inserción de elementos por javascript
  jQuery(document).arrive('.ad_contentCollection', function (localSelf) {
    localSelf.init_sortable();
  }.bind(null, self));

  // Ajustar tamaño de los contents al tamaño de la ventana
  var adjustWidthDebounced = dy_debouncer.debounce(function () { self.adjustWidth(); }, 100);

  window.addEventListener('resize', function() { adjustWidthDebounced(); }, false);

};

ad_contentCollection.prototype.adjustWidth = function() {
  //var self = this;

  // console.log('Ajustarllll');
  var window_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  // console.log('window_width: ' + window_width);

  var content_width = 300;


  var containers = jQuery('.ad_contentCollection');

  containers.each(
    function (/*index*/) {
      var element = jQuery(this);

      var max_width = parseInt(element.attr('data-max-width') );

      if (window_width < max_width) {
        content_width = window_width / 2;
      } else {
        content_width = max_width / 2;
      }

      // console.log('content_width: ' + content_width);

      var contentContainer_width = content_width + 15 + 85;

      // console.log('contentContainer_width: ' + contentContainer_width);

      element.find('.ad_contentCollection_el_container').width( contentContainer_width + 'px');
      element.find('.ad_content_el_componentContainer').width( content_width + 'px');

    }
  );


};

ad_contentCollection.prototype.init_modals = function () {
  var self = this;

  // console.log('Init Modals');

  jQuery(document).on(
    'show.bs.modal',
    function ( event ) {

      var element = jQuery(event.target);

      if (element.hasClass('ad_modal_content_edit')) {

        window.ad_contentCollection.update_modal_edit_position(element);
      }
    }
  );


  jQuery(document).on(
    'hide.bs.modal',
    function ( event ) {

      // console.log('cerrar modal');
      // console.log(event.target);

      var element = jQuery(event.target);

      var id_modal = jQuery(element).attr('id');

      var clean_modal = false;

      // Creación de nuevos Contenidos
      if (element.hasClass('ad_modal_content_new')) {

        // console.log('cerrar modal de creación de contents');

        window.ad_contentCollection.close_modal_form(id_modal, true);

        clean_modal = true;

      }
      // // Edición de contenidos existentes
      else if (element.hasClass('ad_modal_content_edit')) {

        // console.log('cerrar modal de edición de contents');

        clean_modal = true;

      }


      if (clean_modal) {

        var url_ajax_clean = element.data('url');

        $.ajax({
          url: url_ajax_clean,
          method: 'GET'
        });

      }



    });


  };

  ad_contentCollection.prototype.init_sortable = function () {
    var self = this;

    var containers = jQuery('.ad_contentCollection');

    containers.each(
      function (/*index*/) {
        var element = jQuery(this);

        if (element.hasClass('st_mounted') === false) {

          // Init Sticky Menú
          self.init_sticky_menu(element);

          var menu = element.find('.ad_contentCollection_el_menuList');

          // Init Lateral Menú
          self.init_lateral_menu(menu);

          var container = element.find('.ad_contentCollection_el_container');

          // Init Dragula
          self.init_dragula(menu, container);

          // Update hidden field
          // self.update_sortable(container);

          // Mark Element as mounted for future initializations
          element.addClass('st_mounted');
        }
      }
    );

  };

  ad_contentCollection.prototype.init_sticky_menu = function (element) {
    var self = this;

    // init controller
    var controller = new ScrollMagic.Controller({
      refreshInterval: 100
    });

    // get trigger element
    var trigger = element.find('.ad_contentCollection_el_menuContainer');

    // Creamos la scene de ScrollMagic
    var scene_1 = new ScrollMagic.Scene({
      triggerElement: trigger[0],
      triggerHook: 0
    });

    // Toogle class to fix element
    var menu_sticky = element.find('.ad_contentCollection_el_menu');
    // scene_1.setClassToggle(menu_sticky[0], 'st_fixed')

    var instance = menu_sticky;

    // event LEAVE
    scene_1.on('leave', function (localSelf, localInstance, event) {
      // console.log('scene_1: leave');
      localInstance.removeClass('st_fixed');
    }.bind(null, self, instance));

    // event CHANGE
    scene_1.on('change', function (localSelf, localInstance, event) {
      // console.log('scene_1: change');
    }.bind(null, self, instance));

    // event UPDATE
    scene_1.on('update', function (localSelf, localInstance, event) {
      //          console.log('scene_1: update');               
    }.bind(null, self, instance));

    // event PROGRESS
    scene_1.on('progress', function (localSelf, localInstance, event) {
      // console.log('scene_1: progress');               
    }.bind(null, self, instance));

    // event START
    scene_1.on('start', function (localSelf, localInstance, event) {
      // console.log('scene_1: start');
      // console.log('poner fixed');
      localInstance.addClass('st_fixed');
    }.bind(null, self, instance));

    // event END
    scene_1.on('end', function (localSelf, localInstance, event) {
      // console.log('scene_1: end');               
    }.bind(null, self, instance));

    // Add Scene to Controller
    scene_1.addTo(controller);











    var menu_sticky_last = element.find('.ad_contentCollection_el_menu_trigger');
    var menu_fixed = jQuery('.ad_contentCollection_el_menu');
    var menu_fixed_height = menu_fixed.height() + 60;

    menu_sticky_last.css('bottom', menu_fixed_height)

    // Creamos la scene de ScrollMagic
    var scene_2 = new ScrollMagic.Scene({
      triggerElement: menu_sticky_last[0],
      triggerHook: 0
    });

    // event LEAVE
    scene_2.on('leave', function (localSelf, localInstance, event) {
      // console.log('scene_2: leave');
      localInstance.addClass('st_fixed');
      localInstance.removeClass('st_bottom');
    }.bind(null, self, instance));

    // event CHANGE
    scene_2.on('change', function (localSelf, localInstance, event) {
      // console.log('scene_2: change');
    }.bind(null, self, instance));

    // event UPDATE
    scene_2.on('update', function (localSelf, localInstance, event) {
      //          console.log('scene_2: update');               
    }.bind(null, self, instance));

    // event PROGRESS
    scene_2.on('progress', function (localSelf, localInstance, event) {
      // console.log('scene_2: progress');               
    }.bind(null, self, instance));

    // event START
    scene_2.on('start', function (localSelf, localInstance, event) {
      // console.log('scene_2: start');
      // console.log('quitar fixed');
      localInstance.removeClass('st_fixed');
      localInstance.addClass('st_bottom');

    }.bind(null, self, instance));

    // event END
    scene_2.on('end', function (localSelf, localInstance, event) {
      // console.log('scene_2: end');               
    }.bind(null, self, instance));

    // Add Scene to Controller
    scene_2.addTo(controller);






  };

  ad_contentCollection.prototype.init_lateral_menu = function (menu) {
    var self = this;

    // Inicializamos los links para abrir los modals de creación de contents
    menu.find('.ad_contentCollection_el_listLink').each(
      function (/*index*/) {

        var element = jQuery(this);

        element.on('click', function(localSelf, event) {
          event.preventDefault();
          event.stopPropagation();

          var father = event.currentTarget.closest('.ad_contentCollection_el_listElement');

          localSelf.create_newContent(father, false);

        }.bind(null, self));

      }
    );

  };



  ad_contentCollection.prototype.init_dragula = function (menu, container) {
    var self = this;

    // console.log('menu');
    // console.log(menu);

    // console.log('container');
    // console.log(container);

    // Init Dragula for drag & Drop
    // dragula(
    //   [ menu[0], container[0] ],
    //   {
    //     copy: function (el, source) {
    //       return jQuery(source).hasClass('ad_contentCollection_el_menuList');
    //     },
    //     accepts: function (el, target) {
    //       return jQuery(target).hasClass('ad_contentCollection_el_container');
    //     }
    //   }
    // )
    // .on('drop', function (localSelf, el, target, source, sibling) {

    //   // Si nos tiran un elemento desde el menú lateral
    //   if ( jQuery(target).hasClass('ad_contentCollection_el_container') && (target !== source) ) {
    //     localSelf.create_newContent(el, true/*, target, source, sibling*/);

    //   } else {

    //     // Actualizamos el listado de contenidos
    //     localSelf.update_sortable(target);
    //   }

    // }.bind(null, self));


    dragula(
      [ menu[0], container[0] ],
      {
        copy: function (el, source) {
          return jQuery(source).hasClass('ad_contentCollection_el_menuList');
        },
        accepts: function (el, target) {
          return jQuery(target).hasClass('ad_contentCollection_el_container');
        }
      }
    )
    .on('drop', function (localSelf, el, target, source, sibling) {

      // Si nos tiran un elemento desde el menú lateral
      if ( jQuery(target).hasClass('ad_contentCollection_el_container') && jQuery(source).hasClass('ad_contentCollection_el_menuList') ) {
        localSelf.create_newContent(el, true/*, target, source, sibling*/);

      }
      // Si está moviendo contents en el mismo listado
      else if ( jQuery(target).hasClass('ad_contentCollection_el_container') && jQuery(source).hasClass('ad_contentCollection_el_container') ) {

        // Actualizamos el listado de contenidos
        localSelf.update_sortable(target);
      }

    }.bind(null, self));


  };

  ad_contentCollection.prototype.create_newContent = function (el, on_drop/*, target, source, sibling*/) {
    var self = this;

    // console.log('Hay que crear un nuevo content');

    var dropped = jQuery(el);
    var link = dropped.find('.ad_contentCollection_el_listLink');
    var modal_selector = link.attr('data-target');
    var modal = jQuery(modal_selector);

    var position_input = modal.find('#content_position');

    var position;

    if (on_drop) {
      // console.log('por un evento drop');

      // Aumentamos el contador de instancias de dropped
      self.INSTANCES_DROPPED_COUNTER = self.INSTANCES_DROPPED_COUNTER + 1;

      // Marcamos el elemento drop 'fantasma' con un id para futuros usos
      var dropped_id = 'dropped_' + self.INSTANCES_DROPPED_COUNTER;

      dropped.attr('id', dropped_id);

      // Le actualizamos al modal el atributo de data-drop-selector
      modal.attr('data-drop-selector', '#' + dropped_id);

      // Update position
      var items_container = dropped.closest('.ad_contentCollection_el_container');
      var items = items_container.find('> *');
      position = items.index(dropped) + 1;
      position_input.val(position);

      modal.attr('data-position', position);

    } else {
      // console.log('por un click. Irá en la parte de arriba del listado de contents');

      // Le eliminamos al modal el atributo de data-drop-selector
      modal.removeAttr('data-drop-selector');

      // Update position
      position = 1;
      position_input.val(position);
      modal.attr('data-position', position);

    }

    // Bindeamos un evento para cuando se cierre el modal por una acción del usuario
    // modal
    // .unbind('hide.bs.modal')
    // .on('hide.bs.modal', function ( localSelf, event ) {

      // console.log('cerrar modal de creación de contents');

    //   var id_modal = jQuery(event.currentTarget).attr('id');

    //   localSelf.close_modal_form(id_modal, true);

    // }.bind(null, self));

    // Mostramos el modal
    modal.modal('show');

  };


  ad_contentCollection.prototype.dissmiss_content = function (modal) {
    /*var self = this;*/

    // Le quitamos todos los atributos
    modal.removeAttr('data-drop-selector');
    modal.removeAttr('data-position');

    var drop = false;

    var drop_selector = modal.attr('data-drop-selector');
    var dropped = jQuery(drop_selector);

    if ( dropped.length > 0 ) {
      var drop = true;
    }

    // En caso de que el modal se abriese por un evento drop dentro del listado de contents
    if (drop) {

      dropped.slideUp('fast', function () {

        var element = jQuery(this);

        element.remove();

      });

    }

  };

  ad_contentCollection.prototype.add_content = function (html_content, position/*, id_original*/) {
    /*var self = this;*/

    // En caso de que se haya hecho un duplicar de un contenido tenemos que buscar la posición de ese content e insertar el nuevo justo despues
    // la llamada que haría ruby sería algo así: null, data, id_original



    var container = jQuery('.ad_contentCollection_el_container');

    // Si el content es el primero de la lista Quitamos el bloque gris
    if ( container.hasClass('st_empty') ) {
      container.removeClass('st_empty');
    }

    // Comprobamos si hay algún bloque gris en el listado
    var dropped = container.find('.ad_contentCollection_el_listElement');

    var drop = false;

    if (dropped.length > 0) {
      drop = true;
    }

    // Insertar un nuevo contenido desde un drop en el listado
    if (drop) {

      dropped.slideUp('fast', function (localHtml_content, localDropped/*, localModal*/) {

        var fantasma = jQuery(localDropped);

        var divItem = jQuery(localHtml_content);

        divItem.insertBefore(fantasma);

        var aContainer = fantasma.closest('.ad_contentCollection_el_container');

        fantasma.remove();

        // Actualizamos la anchura de los contents
        window.ad_contentCollection.adjustWidth();

        window.ad_contentCollection.update_sortable(aContainer);

      }.bind(null, html_content, dropped/*, modal*/));

    }
    // Insertar un nuevo contenido desde un click en el menú lateral
    // Insertar un nuevo contenido que ha sido duplicado
    else {

      var position_int = parseInt(position);

      var container_elements = container.find('.ad_contentCollection_el_contentContainer');

      var div_item = jQuery(html_content);

      // Si la lista esta vacia o es el primer elemento de la lista
      if (container_elements.length <= 0 || position_int === 1) {

        container.prepend(div_item);

      }
      // Se trata de un duplicate y hay que meter el content en medio de la lista
      else {
        div_item.insertAfter(container_elements[position_int - 2]);
      }

      // Actualizamos la anchura de los contents
      window.ad_contentCollection.adjustWidth();

      window.ad_contentCollection.update_sortable(container);
    }















    // var modal = form.closest('.ad_modal');

    // var drop = false;

    // var drop_selector = modal.attr('data-drop-selector');
    // var dropped = jQuery(drop_selector);

    // if ( dropped.length > 0 ) {
    //   var drop = true;
    // }

    // var container = jQuery('.ad_contentCollection_el_container');

    // if ( container.hasClass('st_empty') ) {
    //   container.removeClass('st_empty');
    // }

    // // En caso de que el modal se abriese por un evento drop dentro del listado de contents
    // if (drop) {

    //   dropped.slideUp('fast', function (localData, localDropped, localModal) {

    //     var fantasma = jQuery(localDropped);

    //     var divItem = jQuery(localData);

    //     divItem.insertBefore(fantasma);

    //     localModal.modal('hide');

    //     localDropped.slideUp('fast', function () {
    //       var element = jQuery(this);

    //       var aContainer = element.closest('.ad_contentCollection_el_container');

    //       element.remove();

    //       window.ad_contentCollection.update_sortable(aContainer);
    //     });

    //   }.bind(null, data, dropped, modal));

    // }
    // // En caso de que el modal se abriese por un evento click en el menú lateral
    // else {

    //   var div_item = jQuery(data);

    //   container.prepend(div_item);

    //   modal.modal('hide');

    //   window.ad_contentCollection.update_sortable(container);
    // }



  };

  ad_contentCollection.prototype.update_content = function (html_content, position/*, id_original*/) {
    /*var self = this;*/

    // var container = jQuery('.ad_contentCollection_el_container');

    // var container_elements = container.find('.ad_contentCollection_el_contentContainer');

    // var position_int = parseInt(position);

    // var element = jQuery(container_elements[position_int - 1]);

    var new_html = jQuery(html_content).find('.ad_content');

    var id = new_html.attr('id');

    if( $(".ad_contentCollection_el_container").find('#'+id).length == 0 ) {
      window.ad_contentCollection.add_content(html_content, position);
    } else {
      var element = jQuery('#' + id).parent();

      element.html(new_html);
    }

  };


  ad_contentCollection.prototype.update_sortable = function (/*container*/) {
    //var self = this;

    var container = jQuery('.ad_contentCollection_el_container');

    // console.log(container);

    var id_string = '';

    var contents = jQuery(container).find('.ad_content');

    for (var i = 0; i < contents.length; ++i) {
      if (i === 0) {
        id_string = jQuery(contents[i]).attr('id');
      } else {
        id_string = id_string + '@' + jQuery(contents[i]).attr('id');
      }

    }

    // console.log('Nuevo orden del ad_contentCollection');
    // console.log(id_string);

    //ad_contentCollection_el_inputOrder

    var component_instance = jQuery(container.closest('.ad_contentCollection'));

    var inputOrder = component_instance.find('.ad_contentCollection_el_inputOrder');

    $.ajax({
      url: component_instance.data('url'),
      method: 'POST',
      data: {sort_data: id_string}
    });

    // Refresh the input hidden with the new Order
    inputOrder.val(id_string);

  };

  ad_contentCollection.prototype.hide_content = function (id_content) {
    var self = this;

    // Llamada de ejemplo:
    // window.ad_contentCollection.hide_content('#id_201');

    // Tenemos que vigilar si con la ocultación de este content dejamos el listado vacio.
    // En ese caso añadimos la clase st_empty al contenedor

    // Primero ocultamos con una animación el content y lo dejamos ahí por si quieren hacer Undo

    var content = jQuery('#' + id_content);

    var container = content.closest('.ad_contentCollection_el_contentContainer');

    container.addClass('st_hidden');

    container.slideUp('fast', function () {});

    var collection_container = container.closest('.ad_contentCollection_el_container');

    var collection_elements = collection_container.find('.ad_contentCollection_el_contentContainer');

    // Quitamos los elementos ocultos
    collection_elements = collection_elements.not('.st_hidden');

    if (collection_elements.length <= 0) {
      collection_container.addClass('st_empty');
    }

    // Actualizamos el orden
    self.update_sortable();

  };

  ad_contentCollection.prototype.show_content = function (id_content) {
    var self = this;

    // Llamada de ejemplo:
    // window.ad_contentCollection.show_content('id_201');

    // Tenemos que vigilar si al volver a mostrar de este content dejamos el listado vacio.
    // En ese caso añadimos la clase st_empty al contenedor

    // Mostramos con una animación el content

    var content = jQuery('#' + id_content);

    var container = content.closest('.ad_contentCollection_el_contentContainer');

    container.removeClass('st_hidden');

    container.slideDown('fast', function () {});

    var collection = container.closest('.ad_contentCollection_el_container');

    if ( collection.hasClass('st_empty') ) {
      collection.removeClass('st_empty');
    }

    // Actualizamod el orden
    self.update_sortable();

  };

  ad_contentCollection.prototype.update_modal_form = function (id_modal, modal_html) {
    //var self = this;

    // ejemplo de llamada
    // window.ad_contentCollection.update_modal_form('text');

    // recibimos el id del modal

    // Si es un modal de NEW CONTENT abierto y se repinta para mostrar los errores, tendríamos que coger el position desde
    // el modal y ponerlo en el hidden input

    // También la llamaremos cuando se oculte el modal y queramos limpiarlo para futuros usos
    // Llamada ajax a Ruby y nos devolverán el contenido limpio para la siguiente apertura

    var modal = jQuery('#' + id_modal);

    var is_open = modal.hasClass('in');

    var position;

    if (modal[0].hasAttribute("data-position")) {
      position = modal.attr('data-position');
    }

    // Actualizamos el html del modal
    modal.html(modal_html);

    // Si está abierto y tiene una position
    if ( is_open && (position !== undefined)) {
      var input_position = modal.find('#content_position');

      input_position.val(position);
    }

  }

  ad_contentCollection.prototype.close_modal_form = function (id_modal, user) {
    //var self = this;

    var modal = jQuery('#' + id_modal);

    // Si el modal lo ha cerrado el usuario
    if (user === true) {

      var drop = false;

      var drop_selector = modal.attr('data-drop-selector');
      var dropped = jQuery(drop_selector);

      if ( dropped.length > 0 ) {
        var drop = true;
      }

      // En caso de que el modal se abriese por un evento drop dentro del listado de contents
      if (drop) {

        dropped.slideUp('fast', function () {

          var element = jQuery(this);

          element.remove();

        });

      }

    }
    // Si el modal lo ha cerrado una edición o creación exitosa de content
    else {

      // console.log(modal);

      // Disparamos la ocultación
      modal.modal('hide');

    }

    // Le quitamos todos los atributos
    modal.removeAttr('data-drop-selector');
    modal.removeAttr('data-position');

  };

  ad_contentCollection.prototype.update_modal_edit_position = function (modal) {
    var self = this;

    var modal_id = modal.attr('id');

    var clean_id = modal_id.replace('form_', '');

    var container = jQuery('.ad_contentCollection_el_container');

    var contents = container.find('.ad_content');

    var position = 1;

    for (var i = 0; i < contents.length; ++i) {

      var element = jQuery(contents[i]);

      var local_id = element.attr('id');

      if (local_id.includes(clean_id)) {
        // console.log('ok: ' + local_id);
        position = i +1;
        break
      } else {
        // console.log('ko: ' + local_id);
      }

    }

    var position_input = modal.find('#content_position');

    position_input.val(position);

  }

  ad_contentCollection.prototype.add_form_edit = function (id_container, id_modal, modal_html) {
    //var self = this;

    // Cuando se crea un nuevo contenido recibiremos el html del formulario de edición de ese content
    // Lo tendríamos que añadir al contenedor: #content_forms

    var container = jQuery('#'+id_container);

    if( $('#'+id_modal).length == 0 ) {
      container.append(modal_html);
    }
  }




  jQuery( document ).ready(function() {

    window.ad_contentCollection = new ad_contentCollection();

  });
